import { navigate as routingNavigate } from "svelte-routing";

interface NavigationListeners {
    [key: string]: (to: string|null) => Promise<boolean>;
}

export class Navigation {

    private static listeners: NavigationListeners = {};

    static doSomething(fn: Function) {
        Navigation.navigationPossible().then((possible: boolean) => {
            if (possible) {
                fn();
            }
        });
    }

    static navigate(to: string) {
        Navigation.navigationPossible().then((possible: boolean) => {
            if (possible) {
                routingNavigate(to);
            }
        });
        /*let promisses = [];
        for (let i in Navigation.listeners) {
            promisses.push(Navigation.listeners[i](to));
        }
        if (promisses.length) {
            Promise.all(promisses).then(response => {
                let rejected = response.filter((r) => r === false);
                if (!rejected.length) {
                    routingNavigate(to);
                }
            });
        } else {
            routingNavigate(to);
        }*/
    }

    static navigationPossible(to: string|null = null): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            let promisses = [];
            for (let i in Navigation.listeners) {
                promisses.push(Navigation.listeners[i](to));
            }
            if (promisses.length) {
                Promise.all(promisses).then(response => {
                    let rejected = response.filter((r) => r === false);
                    resolve(rejected.length === 0)
                });
            } else {
                resolve(true);
            }
        });
    }

    static addListener(id: string, listener: (to: string|null) => Promise<boolean>) {
        if (!Navigation.listeners[id]) {
            Navigation.listeners[id] = listener;
        }
    }

    static removeListener(id: string) {
        if (Navigation.listeners[id]) {
            delete(Navigation.listeners[id]);
        }
    }

}